import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaccsreportpopupComponent } from '../paccsreportpopup/paccsreportpopup.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import * as moment from 'moment';
import { AdministrativeMappingService } from 'src/app/services/administrative-mapping.service';


@Component({
  selector: 'app-makkaludanmudhalvarschemecampreport',
  templateUrl: './makkaludanmudhalvarschemecampreport.component.html',
  styleUrls: ['./makkaludanmudhalvarschemecampreport.component.scss']
})
export class MakkaludanmudhalvarschemecampreportComponent implements OnInit {
  form: FormGroup;
  subdivisionList: any[];
  filtersubdivision: any[];
  filtersubdivisionList: any[];
  divisionList: any[];
  filterdivisionList: any[];
  regionList: any;
  filterregionList: any;
  registeredSubDivisionId: any;
  scheduledEndmax: any;
  scheduleStartmin: any;
  currentDate: any;
  financialYearList: any[] = [];


  constructor(
    private formBuilder: FormBuilder,
    public tripDialog: MatDialog,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private administrativeMappingService: AdministrativeMappingService,

  ) {
    this.regionList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.filterregionList = [];
    this.filterdivisionList = [];
    this.filtersubdivisionList = [];
  }

  ngOnInit(): void {
    this.currentDate = moment(new Date()).format('YYYY-MM-DD');
    this.initializeValidators();
    this.getfinancialyear(true);
    this.form.controls['regionId'].setValue('0');
    this.form.controls['divisionId'].setValue('0');
    this.form.controls['subDivisionId'].setValue('0');
    // this.getLookupRegion(true);

    this.scheduleStartmin = moment(new Date("'2024-07-11'")).format('YYYY-MM-DD');
    this.scheduledEndmax = moment(new Date()).add(0, 'days').format('YYYY-MM-DD');

  }
  initializeValidators() {

    this.form = this.formBuilder.group({

      regionId: ['', Validators.required],
      divisionId: ['', Validators.required],
      subDivisionId: ['', Validators.required],
      ScheduledStart: ['2024-07-11'],
      ScheduledEnd: [this.currentDate],
    });
  }


  clearregionFilter() {
    this.filterregionList = this.regionList;
  }


   getfinancialyear(refresh: boolean) {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (result) {
        this.financialYearList = result;
      }
      this.getLookupRegion(true);
    });
  }

  getFinYearIdByDate(date?: any) {
    const selectedDate = date ? moment(date) : moment();

    const matchedFinYear = this.financialYearList?.find(x => {
      const finYearStart = moment(`${x.startYear}-04-01`);
      const finYearEnd = moment(`${x.endYear}-03-31`);
      return selectedDate.isBetween(finYearStart, finYearEnd, 'day', '[]');
    });

    return matchedFinYear?.key ?? 0;
  }

  getLookupRegion(refresh: boolean) {
     const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getRegions(refDate, refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        const regionLength = this.regionList.length;
        this.filterregionList = this.regionList.slice();
        // if (regionLength == 1) {

        //   this.getLookupDivision(this.form.value.regionId);

        // }

        if (regionLength == 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);

        }
      }
    })
  }


  regionChange(event) {
    this.getLookupDivision(this.form.value.regionId);

    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.form.controls['divisionId'].setValue('0');
    this.form.controls['subDivisionId'].setValue('0');
  }

  clearregiondivsionFilter() {
    this.filterdivisionList = this.divisionList.slice();
  }

  getLookupDivision(id) {
     const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        const divisionLength = this.divisionList.length;
        this.filterdivisionList = this.divisionList.slice();
        if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);
        }
      } else {
      }
    })
  }

  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);

    this.form.controls['subDivisionId'].setValue('0');

  }
  clearregionsubdivsionFilter() {
    this.filtersubdivision = this.subdivisionList.slice();
  }

  getLookupSubDivision(id) {
     const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getSubDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filtersubdivision = [];
        this.subdivisionList = result.filter(x => x.key != this.registeredSubDivisionId);
        this.filtersubdivision = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList.length;
        if (subdivisionLength === 1) {
          this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
        }
      }
    })
  }

  clear() {
    this.form.reset({
      regionId: '0',
      divisionId: '0',
      subDivisionId: '0',
      ScheduledStart: '2024-07-11',
      ScheduledEnd: this.currentDate,
    });

    this.regionList = [];
    this.filterregionList = [];
    this.divisionList = [];
    this.filterdivisionList = [];
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.getLookupRegion(true);
  }
  setDate() {
    this.scheduledEndmax = moment(new Date()).add(0, 'days').format('YYYY-MM-DD');

    this.form.controls["regionId"].setValue(0);
    this.form.controls["divisionId"].setValue(0);
    this.form.controls["subDivisionId"].setValue(0);

    this.getLookupRegion(true);
  }

  showReport2() {
    if (this.form.valid) {
      let startDate = moment(this.form.get('ScheduledStart').value).format('YYYY-MM-DD');
      let endDate = moment(this.form.get('ScheduledEnd').value).format('YYYY-MM-DD');
      const data = {
        regionId: this.form.value.regionId,
        divisionId: this.form.value.divisionId,
        subDivisionId: this.form.value.subDivisionId,
        reportType: 35,
        startTs: startDate,
        endTs: endDate,
      };
      const dialogRef = this.tripDialog.open(PaccsreportpopupComponent, {
        autoFocus: false,
        disableClose: true,
        width: '90%',
        height: '90%',
        panelClass: 'mat-dialog-report',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }

  showReport3() {
    if (this.form.valid) {
      let startDate = moment(this.form.get('ScheduledStart').value).format('YYYY-MM-DD');
      let endDate = moment(this.form.get('ScheduledEnd').value).format('YYYY-MM-DD');
      const data = {
        regionId: this.form.value.regionId,
        divisionId: this.form.value.divisionId,
        subDivisionId: this.form.value.subDivisionId,
        reportType: 36,
        startTs: startDate,
        endTs: endDate,

      };
      const dialogRef = this.tripDialog.open(PaccsreportpopupComponent, {
        autoFocus: false,
        disableClose: true,
        width: '100%',
        height: '90%',
        panelClass: 'mat-dialog-report',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    });
  }
}
